export var AuthErrorCodes;
(function (AuthErrorCodes) {
    AuthErrorCodes["Unauthorized"] = "UNAUTHORIZED";
    AuthErrorCodes["InternalError"] = "INTERNAL_ERROR";
    AuthErrorCodes["MissingApiKey"] = "MISSING_API_KEY";
})(AuthErrorCodes || (AuthErrorCodes = {}));
export class AuthError extends Error {
    name;
    code;
    constructor({ message = '', code = AuthErrorCodes.InternalError }) {
        super(message);
        this.name = 'AuthError';
        this.code = code;
    }
}
